import { defineStore } from 'pinia'
import useAuth from '~/composables/useAuth'
import { Auth } from '~/constants/general'
import { ROLES } from '~/constants/roles'

export const useAuthStore = defineStore('auth', () => {
  const auth = useAuth()
  const user = computed(() => auth.user.value)
  const hasLithiumForecastRole = computed(() =>
    user.value[Auth.auth0RolesProperty].roles.includes(ROLES.LITHIUM_FORECAST_READ),
  )

  return {
    user,
    hasLithiumForecastRole,
  }
})
